import React from 'react'
import styled from 'styled-components'
import social from '../../shared/data/social.mjs'
import {BodyText} from './text.js'
import Link from './link.js'
import theme from './theme.js'
import media from './theme-media.js'
import SearchIcon from './icon-inline-search.js'
import useApp from './use-app-context.js'

const UnstyledNavSocial = ({
  className
}) => {
  const app = useApp()
  const search = app.search

  const props = {
    className 
  }

  const items = Object.keys(social).map(key => {
    const item = social[key]
    const abr = item.key

    const props = {
      item
    }

    return (
      <Item {...item}>
        <Title>{abr}</Title>
      </Item>
    )
  })

  const onClick = () => {
    search.show()
  } 

  const searchProps = {onClick}

  return (
    <div {...props}>
      {items}
      <Search {...searchProps}>
        <Icon/>
      </Search>
    </div>
  )
}

const NavSocial = styled(UnstyledNavSocial)`
  display: flex;
  align-items: center;

  ${media.belowLaptop`
    display: none;
  `}

  &:before {
    content: '';
    margin-left: 2em;
    margin-top:4%;
    width: 5px;
    height: 5px;
    background: rgba(0,0,0,.5);
  }
`

const Item = styled(Link)`
  margin-left: 2em;
`

const Title = styled(BodyText)`
  font-size: ${theme.font.size.p2};
`

const Search = styled.div`
  cursor: pointer;
`

const Icon = styled(SearchIcon)`
  font-size: ${theme.font.size.p2};
  margin-left: .9em;
  opacity: 1;
`

export default NavSocial